import { h } from 'preact';
import { connect } from 'preact-redux';

import { Link } from 'preact-router/match'

import { find } from 'lodash';

import './BlogIndexPage.scss';

import Sidebar from '../components/Sidebar';
import LoadingSpinner from './LoadingSpinner';

import formatDate from '../util/format-date';

const BlogPostListItem = ({ post }) => (
    <li style="margin-bottom: 12px;" class="blog-post-list__item">
        <Link href={post.sitePath}>{post.attributes.title}</Link>
        <p>{formatDate(post.attributes.date)}</p>
    </li>
);

const BlogIndexPage = ({ posts }) => {
    posts.sort((a, b) => {
        return b.attributes.date - a.attributes.date;
    });

    return (
        <div class="page">
            <main class="page-main">
                <div class="page-container">
                    <h1>Blogbejegyzések</h1>
                    <ul class="blog-post-list">
                        {posts.map(post => <BlogPostListItem post={post} />)}
                    </ul>
                </div>
            </main>
            <Sidebar />
        </div>
    );
};

const mapStateToProps = state => ({
    posts: state.pages.filter(p => p.sitePath.startsWith('/blog/'))
});

export default connect(mapStateToProps)(BlogIndexPage);


// WEBPACK FOOTER //
// ./src/components/BlogIndexPage.js